import { render, staticRenderFns } from "./WebSiteCourseBannerList.vue?vue&type=template&id=a48d3584&scoped=true"
import script from "./WebSiteCourseBannerList.vue?vue&type=script&lang=js"
export * from "./WebSiteCourseBannerList.vue?vue&type=script&lang=js"
import style0 from "./WebSiteCourseBannerList.vue?vue&type=style&index=0&id=a48d3584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48d3584",
  null
  
)

export default component.exports